class ProductUpsells {
  init() {
    this.containers = document.querySelectorAll("[data-upsell-container]");
    this.productForm = document.querySelector("product-form");
    this.form = this.productForm?.querySelector('form[action="/cart/add"]');
    this.cartDrawer = document.querySelector("cart-drawer");
    if (!this.containers.length || !this.form) return;
    this.initializeEventListeners();
    this.updateTotal();
  }

  initializeEventListeners() {
    this.containers.forEach(container => {
      container.querySelectorAll("[data-upsell-item]").forEach(item => {
        item.addEventListener("click", () => {
          if (item.dataset.disabled === "true") return;
          const isSelected = item.dataset.selected === "true";
          item.dataset.selected = (!isSelected).toString();
          const itemImage = item.querySelector(".upsell-item-image");
          const plusIcon = item.querySelector(".upsell-plus-icon");
          if (isSelected) {
            if (itemImage) itemImage.style.border = "2px solid transparent";
            if (plusIcon) {
              plusIcon.style.background = "rgba(0, 0, 0, 0.5)";
              plusIcon.style.color = "white";
              plusIcon.style.transform = "rotate(0deg)";
            }
          } else {
            if (itemImage) itemImage.style.border = "2px solid white";
            if (plusIcon) {
              plusIcon.style.background = "white";
              plusIcon.style.color = "black";
              plusIcon.style.transform = "rotate(45deg)";
            }
          }
          this.updateTotal();
        });
      });
    });

    this.form.addEventListener("submit", event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.addToCart();
    }, true);
  }

  getSelectedUpsells() {
    let selectedUpsells = [];
    this.containers.forEach(container => {
      const items = container.querySelectorAll('[data-upsell-item][data-selected="true"]');
      selectedUpsells = selectedUpsells.concat(Array.from(items));
    });
    return selectedUpsells;
  }

  updateTotal() {
    this.containers.forEach(container => {
      const totalElement = container.parentElement.querySelector("[data-upsell-total]");
      let containerTotal = 0;
      container.querySelectorAll('[data-upsell-item][data-selected="true"]').forEach(item => {
        containerTotal += parseInt(item.dataset.price) || 0;
      });
      if (totalElement) {
        totalElement.textContent = containerTotal > 0
          ? `+${(containerTotal / 100).toLocaleString("en-US", { style: "currency", currency: "USD" })}`
          : "";
      }
    });
  }

  syncEmptyClass(itemCount) {
    if (!this.cartDrawer) return;
    const isEmpty = itemCount === 0;
    this.cartDrawer.classList.toggle("is-empty", isEmpty);
    const drawerInner = this.cartDrawer.querySelector(".drawer__inner");
    if (drawerInner) drawerInner.classList.toggle("is-empty", isEmpty);
  }

  async addToCart() {
    const submitButton = this.form.querySelector('[type="submit"]');
    const spinner = this.form.querySelector(".loading__spinner");
    try {
      if (submitButton) {
        submitButton.setAttribute("aria-disabled", "true");
        submitButton.classList.add("loading");
      }
      spinner?.classList.remove("hidden");

      if (this.cartDrawer?.classList.contains("active")) {
        this.cartDrawer.close();
        await new Promise(resolve => setTimeout(resolve, 300));
      }

      const formData = new FormData(this.form);
      const mainProductId = formData.get("id");
      const quantity = parseInt(formData.get("quantity")) || 1;
      const selectedUpsells = this.getSelectedUpsells();

      const items = [{ id: parseInt(mainProductId), quantity }];
      selectedUpsells.forEach(item => {
        const variantId = item.dataset.variantId;
        if (variantId) {
          items.push({
            id: parseInt(variantId),
            quantity: 1,
            properties: { _upsell_for: mainProductId }
          });
        }
      });

      const sections = this.cartDrawer?.getSectionsToRender?.().map(s => s.id) || [];
      const sectionsUrl = window.location.pathname;

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items, sections, sections_url: sectionsUrl })
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.description || errData.message || "Cart add failed");
      }
      const parsed = await response.json();

      this.getSelectedUpsells().forEach(item => {
        item.dataset.selected = "false";
        const itemImage = item.querySelector(".upsell-item-image");
        const plusIcon = item.querySelector(".upsell-plus-icon");
        if (itemImage) itemImage.style.border = "2px solid transparent";
        if (plusIcon) {
          plusIcon.style.background = "rgba(0, 0, 0, 0.5)";
          plusIcon.style.color = "white";
          plusIcon.style.transform = "rotate(0deg)";
        }
      });
      this.updateTotal();

      const cartRes = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartState = await cartRes.json();
      const itemCount = cartState.item_count ?? 0;

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-upsells",
          productVariantId: mainProductId,
          cartData: parsed
        });
      }

      if (this.cartDrawer && parsed.sections) {
        this.syncEmptyClass(itemCount);
        this.cartDrawer.renderContents(parsed);
        // Re-assert the empty class after async clobberers (cart-drawer-items
        // re-fetches its section, and the free-gift app may also re-render).
        setTimeout(() => this.syncEmptyClass(itemCount), 0);
        setTimeout(() => this.syncEmptyClass(itemCount), 150);
        setTimeout(() => this.syncEmptyClass(itemCount), 500);
      } else if (this.cartDrawer) {
        this.syncEmptyClass(itemCount);
        this.cartDrawer.open();
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      const errorMessage = document.createElement("div");
      errorMessage.classList.add("product-form__error-message");
      errorMessage.textContent = error.message || "Error adding products to cart. Please try again.";
      this.form.appendChild(errorMessage);
      setTimeout(() => errorMessage.remove(), 3000);
    } finally {
      if (submitButton) {
        submitButton.removeAttribute("aria-disabled");
        submitButton.classList.remove("loading");
      }
      spinner?.classList.add("hidden");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll("[data-upsell-container]").length > 0) {
    new ProductUpsells().init();
  }
});
